export default __webpack_public_path__ + "static/media/exemples.85b7ff89.md";